<template lang="html">
  <scene-content v-bind="$props" />
</template>

<script>
  import SceneContent from './SceneContent';

  export default {
    name: 'ProcessInterviewScene',

    components: {
      SceneContent
    },

    props: {
      interview: {
        type: Object,
        default: null
      },

      vacancy: {
        type: Object,
        default: null
      },

      loading: {
        type: Boolean,
        default: false
      },

      fetch: {
        type: Function,
        default: () => {}
      },

      fromRegistration: {
        type: Boolean,
        default: false
      },

      error: {
        type: Object,
        default: () => {}
      }
    }
  };
</script>
